module.exports = __webpack_public_path__ + "img/rocket-group.d246ac5a.png";